import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.51 17.38 16.93 18.28C15.57 19.36 13.86 20 12 20C10.14 20 8.43 19.36 7.07 18.28ZM18.36 16.83C16.93 15.09 13.46 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.62 15.49 4 13.82 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.49 18.36 16.83ZM12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.7954 11.3862C13.4723 10.4294 13.87 9.26116 13.87 8C13.87 4.75809 11.2419 2.13 8 2.13C4.75809 2.13 2.13 4.75809 2.13 8C2.13 9.26115 2.52772 10.4294 3.20456 11.3862C4.0643 10.6462 5.61606 9.93506 7.99998 9.93506C10.3839 9.93506 11.9357 10.6462 12.7954 11.3862ZM12.0562 12.2431C11.4473 11.7193 10.1956 11.0651 7.99998 11.0651C5.80437 11.0651 4.55265 11.7193 3.94375 12.2431C4.99773 13.2509 6.42657 13.87 8 13.87C9.57342 13.87 11.0023 13.2509 12.0562 12.2431ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 7.87C8.75663 7.87 9.37 7.25663 9.37 6.5C9.37 5.74337 8.75663 5.13 8 5.13C7.24337 5.13 6.63 5.74337 6.63 6.5C6.63 7.25663 7.24337 7.87 8 7.87ZM8 9C9.38071 9 10.5 7.88071 10.5 6.5C10.5 5.11929 9.38071 4 8 4C6.61929 4 5.5 5.11929 5.5 6.5C5.5 7.88071 6.61929 9 8 9Z"
  />
);

export const AccountCircleIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="AccountCircle" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
